import { useTranslation } from "react-i18next";

import { createFormHelper } from "lib/Form";
import { LocationCheckboxes } from "modules/AccountSettings/components/LocationSettingsSection/components";

import type { User } from "models";

type LocationSettingsSectionProps = {
  selectedLocations: number[];
  handleSelectLocation: (id: number) => void;
};

const FormHelper = createFormHelper<User>();

export const LocationSettingsSection = ({ handleSelectLocation, selectedLocations }: LocationSettingsSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="setting_section location">
      <h2>{t("v8_locations", "Locations")}</h2>

      <div className="location-visibility-wrapper">
        <FormHelper.Field.Checkbox name="location_column_visible" label={t("v8_locations_column_visible", "Locations column visible")} />
      </div>

      <LocationCheckboxes handleSelectLocation={handleSelectLocation} selectedLocations={selectedLocations} />
    </div>
  );
};
